import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, ChevronDownIcon, Switch, Typography} from "convertupleads-theme";

const SwitchAccordion = ({title,children}) => {
    return (
            <Accordion>
                <AccordionSummary
                    expandIcon={
                        <ChevronDownIcon fontSize="small" color={"text.tertiary"} />
                    }
                    sx={{
                        flexDirection: "row-reverse",
                        "& .MuiAccordionSummary-content": {
                            justifyContent: "space-between",
                        },
                    }}
                >
                    <Typography
                        variant={"button"}
                        color={"text.secondary"}
                        sx={{ textTransform: "normal" }}
                    >
                        {title}
                    </Typography>
                    <Switch variant={"onOff"} color={"primary"} defaultChecked />
                </AccordionSummary>
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            </Accordion>
    );
};

export default SwitchAccordion;